module.exports = __webpack_public_path__ + "images/application/illustrations/manual-d261bb45.svg";